import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import AutoLocation from "sr/helpers/ui-components/AutoLocation";

type AddressType = {
  address_line_1?: string;
  address_line_2?: string;
  country?: string;
  city?: string;
  state?: string;
  postal?: string;
  lat?: number;
  lng?: number;
  region?: string;
};

type Props = {
  data: { address?: AddressType };
  HandleDataProps: (payload: { address: AddressType }) => void;
  externalErrorId?: string;
  externalErrorPath?: string;
};

const RequirementAddressChange = forwardRef(
  ({ data, HandleDataProps, externalErrorId, externalErrorPath }: Props, ref) => {
    const [address, setAddress] = useState<AddressType>({});
    const [localErrors, setLocalErrors] = useState<any>({});

    useEffect(() => {
      if (data?.address) {
        setAddress(data.address);
      }
    }, [data?.address]);

    useImperativeHandle(ref, () => ({
      validateData: () => {
        const errs: any = {};
        if (!address?.address_line_1) {
          errs.address_line_1 = 'INPUT.VALIDATION.AUTOLOCATION.ADDRESSLINE1';
        }
        if (!address?.country) {
          errs.country = 'INPUT.VALIDATION.AUTOLOCATION.COUNTRY';
        }
        setLocalErrors(errs);
        return Object.keys(errs).length === 0;
      },
      submitForm: () => {
        const newData = { address };
        HandleDataProps(newData);
        return newData;
      },
    }));

    return (
      <div className="space-y-4">
        <p className="text-sm font-medium text-gray-700">Update Address</p>
        <AutoLocation
          HandleAutoLocation={(data: AddressType) => {
            setAddress(data); // keep local state in sync
          }}
          errors={
            (externalErrorPath && externalErrorId && externalErrorPath.startsWith('address.'))
              ? { [externalErrorPath.split('.')[1]]: externalErrorId }
              : localErrors
          }
        />
      </div>
    );
  }
);

export default RequirementAddressChange;
